import React, { useState, useEffect } from "react";
import moment from "moment";
import { formatMoneda } from "../../../util/varios";
import useTableR from "../../useTableR";
import { Dimmer } from "../../spinner";
import { Mensaje } from "../../mensajes2";
import axios from "axios";
const TablaPagosVehiculos = (props) => {
  const token = localStorage.getItem("jwtToken");
  const op = require("../../../modulos/datos");
  const espiritu = localStorage.getItem("espiritu");
  const fechaSistema = localStorage.getItem("fechasistema");
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const headCells = [
    {
      id: "anio",
      label: "AÑO",
      width: "50px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
    {
      id: "mes",
      label: "MES",
      width: "80px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
    {
      id: "monto",
      label: "MONTO",
      width: "150px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
    {
      id: "intereses",
      label: "INTERES MORA",
      width: "150px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
    {
      id: "recargo",
      label: "RECARGOS",
      width: "150px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
    {
      id: "descuento",
      label: "DESCUENTO",
      width: "150px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
    {
      id: "recibo",
      label: "NRO. RECIBO",
      width: "150px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
    {
      id: "fechapago",
      label: "FECHA DE PAGO",
      width: "150px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
  ];
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableR(records, headCells, filterFn);
  const buscarPagosVehiculos = async (idVehiculo) => {
    try {
      setLoading(true);
      const endpoint = `${op.conexion}/api/vehiculo/deudavehiculo?idvehiculo=${idVehiculo}&fecha=${fechaSistema}&espiritu=${espiritu}`;
      const response = await axios.get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      if (
        response.status === 200 &&
        response.data &&
        response.data.length > 0
      ) {
        let pagos = [];
        for (let i = 0; i < response.data.length; i++) {
          if (response.data[i].fechapago !== null) {
            pagos.push({
              anio: response.data[i].anio,
              mes: response.data[i].mes.replace("'", "").replace("'", ""),
              monto: response.data[i].mondeu,
              intereses: response.data[i].intmoradeu,
              recargo: response.data[i].recargodeu,
              multa: response.data[i].multa,
              descuento: response.data[i].mondescue,
              recibo: response.data[i].numreci,
              fechapago: response.data[i].fechapago,
              status: response.data[i].estatus,
              idfac: response.data[i].idfact,
              estatusfac: response.data[i].estatusfac,
              tipotransaccion: response.data[i].tipotransaccion,
            });
          }
        }
        setRecords(pagos);
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "Error al Buscar los Pagos del Vehiculo",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const imprimirHistory = () => {
    try {
      if (props.idVehiculo) {
        const id = "A.IdVehiculo=" + parseInt(props.idVehiculo);
        const crit = " ";
        window.open(
          op.reportes +
            "/impuestovehiculo?" +
            "reporte=HisPago_Vehiculo" +
            "&sql=" +
            id +
            "&crit=" +
            crit,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
        );
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "Error al Generar el Reporte",
        icono: "error",
      });
    }
  };
  useEffect(() => {
    console.log(props.idVehiculo);
    if (props.idVehiculo) {
      buscarPagosVehiculos(props.idVehiculo);
    }
  }, [props.idVehiculo]);

  return (
    <div className="card">
      <div className="card-body">
        <div className="content">
          <div className="container">
            <div align="center" className="col-md-2 ml-auto">
              <button
                style={{ marginBottom: "5px" }}
                onClick={() => imprimirHistory()}
                className="btn btn-primary btn-sm rounded-circle"
              >
                <i className="fas fa-print"></i>{" "}
              </button>
            </div>
            <div className="row">
              <div className="col-md-12" style={{ margin: "auto" }}>
                <TblContainer>
                  <TblHead />

                  <tbody>
                    {records &&
                      recordsAfterPagingAndSorting().map((item, index) => (
                        <tr key={index} style={{ padding: "0" }}>
                          <td style={{ fontSize: "10px", textAlign: "center" }}>
                            {item.anio}
                          </td>
                          <td style={{ fontSize: "10px", textAlign: "center" }}>
                            {item.mes}
                          </td>
                          <td style={{ fontSize: "10px", textAlign: "right" }}>
                            {formatMoneda(
                              item.monto.toString().replace(".", ","),
                              ",",
                              ".",
                              2,
                            )}
                          </td>
                          <td style={{ fontSize: "10px", textAlign: "right" }}>
                            {formatMoneda(
                              item.intereses.toString().replace(".", ","),
                              ",",
                              ".",
                              2,
                            )}
                          </td>
                          <td style={{ fontSize: "10px", textAlign: "right" }}>
                            {formatMoneda(
                              item.recargo.toString().replace(".", ","),
                              ",",
                              ".",
                              2,
                            )}
                          </td>
                          <td style={{ fontSize: "10px", textAlign: "right" }}>
                            {formatMoneda(
                              item.descuento.toString().replace(".", ","),
                              ",",
                              ".",
                              2,
                            )}
                          </td>
                          <td style={{ fontSize: "10px", textAlign: "center" }}>
                            {item.recibo === null ? "" : item.recibo.trim()}
                          </td>
                          <td style={{ fontSize: "10px", textAlign: "center" }}>
                            {moment.utc(item.fechapago).format("DD/MM/YYYY")}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </TblContainer>
                <TblPagination />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({
            mostrar: false,
            titulo: "",
            texto: "",
            icono: "",
          });
        }}
      />
      <Dimmer active={loading} inverted />
    </div>
  );
};

export default TablaPagosVehiculos;
